export default __webpack_public_path__ + "locales/tr/UploadPanel.json?hash=7457bcdf604bf525afe0ee66a420471f";